var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'Edit Profile'},"tag":"a"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"fas fa-address-card"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("My Profile")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b55337de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/MobileMenu.vue
// module id = ht6O
// module chunks = 9